module.exports = __webpack_public_path__ + "static/pic01-f384169d3c9c201216b6a082d2078f35.jpeg";